import { Component } from 'react';
import { HttpRequestService } from '../../services/HttpRequestService';
import moment from 'moment'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { UtilsService } from '../../services/UtilsService';
import Report from '../../common/Report';
import { Link } from "react-router-dom";
import React from 'react';
import { UserService } from '../../services/UserService';

class FieldRepManagedOrdersReport extends Component {

    constructor(props) {
        super(props);
        this.utils = new UtilsService();
        var initialState = {
            beginDate: moment(new Date()).toDate(),
            endDate: moment(new Date()).toDate(),
            fieldRepTerritories: [],
            fieldRepTerritoryId: -1,
            report: null,
        }
        this.sortBy = "";
        this.sortDirection = "";
        this.paramsKey = "params.field-rep-managed-orders-report";
        this.state = this.utils.prepareSessionState(initialState, this.paramsKey);

        this.http = new HttpRequestService();
        this.handleBeginDateChange = this.handleBeginDateChange.bind(this);
        this.handleEndDateChange = this.handleEndDateChange.bind(this);
        this.handleFieldRepTerritoryChange = this.handleFieldRepTerritoryChange.bind(this);
        this.getFieldRepTerritories = this.getFieldRepTerritories.bind(this);
        this.getReport = this.getReport.bind(this);
        this.sortReport = this.sortReport.bind(this);
    }

    componentDidMount() {
        if (!UserService.IsUserInRole("Field Rep")) {
            this.getFieldRepTerritories();
        }
        this.getReport();
    }

    handleBeginDateChange(e) {
        this.setState({ beginDate: e });
    }

    handleEndDateChange(e) {
        this.setState({ endDate: e });
    }

    handleFieldRepTerritoryChange(e) {
        this.setState({ fieldRepTerritoryId: e.target.value });
    }

    getFieldRepTerritories() {
        this.http.get('/api/Admin/GetUserDefinedField?id=11', null).then(data => {
            var fieldRepTerritories = data.options.map((o) => {
                return {
                    id: o.userDefinedFieldOptionID,
                    name: o.name
                }
            });
            this.setState({ fieldRepTerritories: fieldRepTerritories });
        });
    }

    getReport(e) {
        if (!!e) {
            e.preventDefault();
        }
        var params = {
            beginDate: this.state.beginDate != null ? moment(this.state.beginDate).format('L') : "",
            endDate: this.state.endDate != null ? moment(this.state.endDate).format('L') : "",
            fieldRepTerritoryId: this.state.fieldRepTerritoryId,
            sortBy: this.sortBy,
            sortDirection: this.sortDirection
        }

        sessionStorage.setItem(this.paramsKey, JSON.stringify(params));

        this.http.get('/api/Report/GetFieldRepManagedOrdersReport', params).then(data => {
            this.setState({ report: data });
        });
    }

    sortReport(field) {
        if (this.sortBy !== field) {
            this.sortDirection = "ASC";
        }
        else {
            if (this.sortDirection === "ASC") {
                this.sortDirection = "DESC";
            }
            else {
                this.sortDirection = "ASC";
            }
        }
        this.sortBy = field;
        this.getReport();
    }

    render() {
        return (
            <div className="page-inner">
                <div className="page-header">
                    <h4 className="page-title">Field Rep. Managed Orders Report</h4>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <div className="card">
                            <div className="card-body">
                                <form onSubmit={this.getReport}>
                                    <div className="form-row">
                                        <div className="form-group col-md-3">
                                            <label htmlFor="beginDate">Invoices From</label>
                                            <DatePicker className="form-control" selected={this.state.beginDate} onChange={this.handleBeginDateChange} />
                                        </div>
                                        <div className="form-group col-md-3">
                                            <label htmlFor="endDate">Invoices To</label>
                                            <DatePicker className="form-control" selected={this.state.endDate} onChange={this.handleEndDateChange} />
                                        </div>
                                        {!UserService.IsUserInRole("Field Rep") &&
                                            <div className="form-group col-md-3">
                                                <label>Territory</label>
                                                <select className="form-control" value={this.state.fieldRepTerritoryId} onChange={this.handleFieldRepTerritoryChange}>
                                                    <option key="-1" value="-1">-- ALL --</option>
                                                    {this.state.fieldRepTerritories.map(territory =>
                                                        <option key={territory.id} value={territory.id}>{territory.name}</option>
                                                    )}
                                                </select>
                                            </div>
                                        }
                                    </div>
                                    <div className="form-row justify-content-end">
                                        <button type="submit" className="btn btn-primary">Submit</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                        {this.state.report != null &&
                            <Report name="FieldRepManagedOrdersReport" hasData={(this.state.report.customerItems && this.state.report.customerItems.length > 0) || (this.state.report.territoryItems && this.state.report.territoryItems.length > 0)} title="Field Rep. Managed Orders Report" description={this.state.report.description}>
                                <div className="form-row">
                                    {this.state.report.territoryItems.length === 0 &&
                                        <table className="table table-striped mt-1 report-table">
                                            <thead>
                                                <tr>
                                                    <th></th>
                                                    <th className="sortable" scope="col" onClick={(e) => this.sortReport("AccountNumber")}>CUST #</th>
                                                    <th className="sortable" scope="col" onClick={(e) => this.sortReport("Name")}>CUSTOMER</th>
                                                    <th className="sortable" scope="col" onClick={(e) => this.sortReport("udfo.Name")}>TERRITORY</th>
                                                    <th scope="col">ADDRESS LINE 1</th>
                                                    <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderCount")}>ORDERS</th>
                                                    <th scope="col">LAST ORDER DATE</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {this.state.report.customerItems.map((item) =>
                                                    <React.Fragment key={item.customerId}>
                                                        <tr>
                                                            <td>
                                                                <button className="btn btn-link" type="button" onClick={() => {
                                                                    item.detailsVisible = !item.detailsVisible;
                                                                    this.setState({ report: this.state.report });
                                                                }}>{item.detailsVisible ? "-" : "+"}</button></td>
                                                            <td><Link style={{ color: 'inherit' }} to={"/customer/" + item.customerID}>{item.customerNumber}</Link></td>
                                                            <td><Link style={{ color: 'inherit' }} to={"/customer/" + item.customerID}>{item.companyName}</Link></td>
                                                            <td>{item.territory}</td>
                                                            <td>{item.address1}</td>
                                                            <td>{item.orderCount}</td>
                                                            <td>{item.lastOrderDate}</td>
                                                        </tr>
                                                        {item.detailsVisible &&
                                                            <tr>
                                                                <td colSpan={7}>
                                                                    <table className="table table-striped mt-1 ml-4 report-table" style={{ width: "80%" }}>
                                                                        <thead>
                                                                            <tr>
                                                                                <th></th>
                                                                                <th scope="col">ORDER #</th>
                                                                                <th scope="col">DATE</th>
                                                                                <th scope="col">SALESMAN</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            {item.items.map((order) =>
                                                                                <tr key={order.orderID}>
                                                                                    <td></td>
                                                                                    <td><Link to={"/order/" + order.orderID}>{order.orderNumber}</Link></td>
                                                                                    <td>{moment(order.fulfillDate).format('l')}</td>
                                                                                    <td>{order.salesmanInitials}</td>
                                                                                </tr>
                                                                            )}
                                                                        </tbody>
                                                                    </table>
                                                                </td>
                                                            </tr>

                                                        }
                                                    </React.Fragment>
                                                )}
                                            </tbody>
                                            <tbody>
                                                <tr className="bg-dark reportFooter">
                                                    <th colSpan={6}>
                                                        <span>
                                                            TOTAL # of ORDERS
                                                        </span>
                                                    </th>
                                                    <th>{this.state.report.orderCount}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                    {this.state.report.territoryItems.length > 0 &&
                                        <table className="table table-striped mt-1 report-table">
                                            {this.state.report.territoryItems.map((territory) =>
                                                <React.Fragment>
                                                    <thead>
                                                        <tr className="bg-info reportHeader">
                                                            <th colSpan={7}>{territory.territory}</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr>
                                                            <th></th>
                                                            <th className="sortable" scope="col" onClick={(e) => this.sortReport("AccountNumber")}>CUST #</th>
                                                            <th className="sortable" scope="col" onClick={(e) => this.sortReport("Name")}>CUSTOMER</th>
                                                            <th className="sortable" scope="col" onClick={(e) => this.sortReport("udfo.Name")}>TERRITORY</th>
                                                            <th scope="col">ADDRESS LINE 1</th>
                                                            <th className="sortable" scope="col" onClick={(e) => this.sortReport("OrderCount")}>ORDERS</th>
                                                            <th scope="col">LAST ORDER DATE</th>
                                                        </tr>
                                                        {territory.items.map((item) =>
                                                            <React.Fragment key={item.customerId}>
                                                                <tr>
                                                                    <td>
                                                                        <button className="btn btn-link" type="button" onClick={() => {
                                                                            item.detailsVisible = !item.detailsVisible;
                                                                            this.setState({ report: this.state.report });
                                                                        }}>{item.detailsVisible ? "-" : "+"}</button></td>
                                                                    <td><Link style={{ color: 'inherit' }} to={"/customer/" + item.customerID}>{item.customerNumber}</Link></td>
                                                                    <td><Link style={{ color: 'inherit' }} to={"/customer/" + item.customerID}>{item.companyName}</Link></td>
                                                                    <td>{item.territory}</td>
                                                                    <td>{item.address1}</td>
                                                                    <td>{item.orderCount}</td>
                                                                    <td>{item.lastOrderDate}</td>
                                                                </tr>
                                                                {item.detailsVisible &&
                                                                    <tr>
                                                                        <td colSpan={7}>
                                                                            <table className="table table-striped mt-1 ml-4 report-table" style={{ width: "80%" }}>
                                                                                <thead>
                                                                                    <tr>
                                                                                        <th></th>
                                                                                        <th scope="col">ORDER #</th>
                                                                                        <th scope="col">DATE</th>
                                                                                        <th scope="col">SALESMAN</th>
                                                                                    </tr>
                                                                                </thead>
                                                                                <tbody>
                                                                                    {item.items.map((order) =>
                                                                                        <tr key={order.orderID}>
                                                                                            <td></td>
                                                                                            <td><Link to={"/order/" + order.orderID}>{order.orderNumber}</Link></td>
                                                                                            <td>{moment(order.fulfillDate).format('l')}</td>
                                                                                            <td>{order.salesmanInitials}</td>
                                                                                        </tr>
                                                                                    )}
                                                                                </tbody>
                                                                            </table>
                                                                        </td>
                                                                    </tr>

                                                                }
                                                            </React.Fragment>
                                                        )}
                                                    </tbody>
                                                    <tr className="bg-dark reportFooter">
                                                        <th colSpan={6}>
                                                            <span>
                                                                TOTAL # of ORDERS
                                                            </span>
                                                        </th>
                                                        <th>{territory.orderCount}</th>
                                                    </tr>
                                                </React.Fragment>
                                            )}
                                            <tbody>
                                                <tr className="bg-dark reportFooter">
                                                    <th colSpan={6}>
                                                        <span>
                                                            TOTAL # of ORDERS
                                                        </span>
                                                    </th>
                                                    <th>{this.state.report.orderCount}</th>
                                                </tr>
                                            </tbody>
                                        </table>
                                    }
                                </div>
                            </Report>
                        }
                    </div>
                </div >
            </div >
        );
    }
}

export default FieldRepManagedOrdersReport;
